import { AppState } from "./interfaces";

export const initialState: AppState = {
	isFetching: false,
	activePageId: '1',
	activePage: {},
	pages: []
}